import { JsonRecord } from "@/types";
import grey from "@/Assets/Images/grey.png";
import green from "@/Assets/Images/green.png";
import yellow from "@/Assets/Images/yellow.png";
import black from "@/Assets/Images/black.png";
import red from "@/Assets/Images/red.png";
import { StaticImageData } from "next/image";

export const DOT_APP_ID = "01HK7P1WPP6S2YR1ZY7HTBGRV5";
// export const dotServiceID = "01GE31BHWM4MRGQX1D77GE3JDY"; // DOT APP ID
// export const dotAppID = "01HK7N6AE8E5CX7BECCMRV9BXN"; // vendor admin app ID

export const STATUS_ORDER = [
  "new",
  "accepted",
  "qa_qc",
  "ready_for_pickup",
  "picked_up",
  "assigned",
  "delivered",
  "cancelled",
  "dispatch_end",
];

export const DATE_FORMAT = {
  DATE: "DD/MM/YYYY",
  TIME: "hh:mm:ss A",
  DATE_TIME: "DD MMM YYYY hh:mm:ss A",
  DAY: "DD",
  MONTH: "MM",
  YEAR: "YYYY",
  PARAMS: "YYYYMMDD",
  DATE_MMDDYY: "MMM D, YYYY	",
  TIME_HOURS: "HH :mm[h]",
};
export const PHONE_NO_REGEX =
  /^(\+\d{1,4}\s?)?(\(?\d{1,}\)?[\s.-]?)?\d{1,}[\s.-]?\d{1,}$/;

const IMAGE_URL_REGEX =
  /^(https?:\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(\#[-a-z\d_]*)?$/i;

export function isValidURL(url: any) {
  return IMAGE_URL_REGEX.test(url);
}
export const INITIAL_MAP_VIEWPORT = {
  width: 800,
  height: 600,
  latitude: 0,
  longitude: 0,
  zoom: 1,
};
export const MAP_LAYER: any = {
  id: "my-layer",
  type: "symbol",
  source: "my-data",
  layout: {
    "icon-image": "custom-marker",
    "icon-size": 0.2,
    "icon-allow-overlap": true,
  },
};
export const STATUS_COLOR_CODE: JsonRecord = {
  new: "#0086DA",
  accepted: "#7E00B9",
  assigned: "#A6C100",
  qa_qc: "#F8D000",
  ready_for_pickup: "#FAA200",
  picked_up: "#00BFD9",
  delivered: "#008E00",
  cancelled: "#FF0000",
  dispatch_end: "#FF00AA",
  dispatch_start: "#FF00FF",
  dispatch_request: "#FF00AA",
  default: "#AAFF00",
  all: "#6366f115",
  await_customer_input: "#B8E40B",
  order_amended: "#58C3FF",
  none: "#C7CEDF",
};

export type DriverStatus =
  | "inactive"
  | "idle"
  | "on_job"
  | "offline"
  | "accepted"
  | "rejected"
  | "expired";

export const MARKER_IMAGES: Record<DriverStatus, StaticImageData> = {
  inactive: grey,
  idle: green,
  on_job: yellow,
  offline: black,
  accepted: green,
  rejected: red,
  expired: yellow,
};

export const DRIVER_STATUS = [
  { label: "Inactive", value: "inactive" },
  { label: "Idle", value: "idle" },
  { label: "On job", value: "on_job" },
  { label: "Offline", value: "offline" }
];

export const ALGORITHM_TYPE = [
  { label: "Find Nearest", value: "find_nearest" },
  { label: "Almost Available", value: "almost_available" },
]
